import { ComponentType } from 'react'
import styled from 'styled-components'
import { GMap } from './g-map'

const Wrapper = styled.div`
  position: fixed;
  top: calc(70px + 60px);
  left: 0;
  right: 0;
  bottom: 0;
`

interface Props {
  properties: any[]
}

export const MapMobile: ComponentType<Props> = ({ properties }) => (
  <Wrapper>
    <GMap properties={properties} />
  </Wrapper>
)
